import { render, staticRenderFns } from "./overlay-general.vue?vue&type=template&id=4b7473da"
import script from "./overlay-general.vue?vue&type=script&lang=js"
export * from "./overlay-general.vue?vue&type=script&lang=js"
import style0 from "./overlay-general.vue?vue&type=style&index=0&id=4b7473da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports